export const GOOGLE_ADS_CLICK_COOKIE_NAMES = {
  gclid: "_mirofish_gclid",
  gbraid: "_mirofish_gbraid",
  wbraid: "_mirofish_wbraid",
  clickTs: "_mirofish_ads_click_ts",
} as const;

export type GoogleAdsClickMetadata = {
  google_ads_gclid?: string;
  google_ads_gbraid?: string;
  google_ads_wbraid?: string;
  google_ads_click_ts?: string;
};

export function pickGoogleAdsClickId(metadata: Record<string, unknown>) {
  const gclid = asNonEmptyString(metadata.google_ads_gclid);
  const gbraid = asNonEmptyString(metadata.google_ads_gbraid);
  const wbraid = asNonEmptyString(metadata.google_ads_wbraid);

  if (gclid) {
    return { field: "gclid" as const, value: gclid };
  }
  if (gbraid) {
    return { field: "gbraid" as const, value: gbraid };
  }
  if (wbraid) {
    return { field: "wbraid" as const, value: wbraid };
  }

  return null;
}

export function asNonEmptyString(value: unknown) {
  if (typeof value !== "string") {
    return null;
  }
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
}
